import LegalHeader from "@/components/landing/LegalHeader";
import Footer from "@/components/landing/Footer";

export default function PrivacyPolicy() {
  return (
    <main data-testid="privacy-page" className="bg-white text-[#0A0A0A]">
      <LegalHeader />

      <section className="max-w-[820px] mx-auto px-6 md:px-8 py-16 md:py-24">
        <span className="inline-block text-xs uppercase tracking-[0.2em] font-semibold text-[#B40101] mb-4">
          Documento legale
        </span>
        <h1 className="font-display font-bold text-[#0A0A0A] text-4xl md:text-5xl tracking-tight leading-tight">
          Privacy Policy
        </h1>
        <p className="mt-4 text-[#0A0A0A]/60 text-sm">
          Ultimo aggiornamento: 11 dicembre 2026
        </p>

        <div className="prose prose-neutral max-w-none mt-10 space-y-8 text-[#0A0A0A]/85 text-[16px] md:text-[17px] leading-relaxed">

          <p>
            La presente Informativa sulla Privacy descrive le modalità di trattamento dei dati personali
            degli utenti che visitano il sito{" "}
            <a href="https://valutagenio.com" className="text-[#B40101] font-semibold hover:underline">
              valutagenio.com
            </a>{" "}
            (di seguito, il &quot;Sito&quot;) e utilizzano i servizi offerti da ValutaGenio, in conformità al Regolamento (UE) 2016/679 (&quot;GDPR&quot;) e al D.Lgs. 196/2003 e successive modifiche (Codice Privacy italiano).
          </p>

          {/* 1. Titolare */}
          <section data-testid="privacy-section-titolare">
            <h2 className="font-display font-bold text-[#0A0A0A] text-2xl md:text-3xl tracking-tight mt-10 mb-4">
              1. Titolare del trattamento
            </h2>
            <p>
              Il Titolare del trattamento dei dati personali è:
            </p>
            <div className="mt-4 bg-[#F5F5F5] rounded-xl p-5 md:p-6 border border-[#E5E5E5]">
              <p className="mb-1"><strong>Paul Fasciano</strong></p>
              <p className="mb-1">P.IVA: <strong>12849491001</strong></p>
              <p className="mb-1">Sede: Roma, Italia</p>
              <p>
                Email:{" "}
                <a href="mailto:info@valutagenio.com" className="text-[#B40101] font-semibold hover:underline">
                  info@valutagenio.com
                </a>
              </p>
            </div>
          </section>

          {/* 2. Dati raccolti */}
          <section data-testid="privacy-section-dati">
            <h2 className="font-display font-bold text-[#0A0A0A] text-2xl md:text-3xl tracking-tight mt-10 mb-4">
              2. Tipologie di dati raccolti
            </h2>
            <p>
              Il Sito tratta esclusivamente le categorie di dati strettamente necessarie all&apos;erogazione dei servizi richiesti dall&apos;utente. In particolare:
            </p>
            <ul className="list-disc pl-6 space-y-2 mt-3">
              <li>
                <strong>Indirizzo email</strong> — raccolto tramite il modulo di iscrizione alla waitlist del servizio <em>OrizzontiPro</em>, al solo scopo di notificare il lancio del servizio.
              </li>
              <li>
                <strong>Dati immobiliari anonimi</strong> — raccolti tramite il servizio <em>ValutaPro</em> (tipologia, metratura, zona, caratteristiche dell&apos;immobile). Tali dati non sono riconducibili a una persona fisica identificata o identificabile e vengono utilizzati esclusivamente per generare l&apos;analisi richiesta.
              </li>
              <li>
                <strong>Dati di navigazione</strong> — log tecnici (indirizzo IP anonimizzato, tipo di browser, sistema operativo, pagine visitate) raccolti tramite cookie tecnici essenziali per il funzionamento del Sito.
              </li>
            </ul>
            <p className="mt-3">
              <strong>Il Sito non utilizza cookie di profilazione né raccoglie dati per finalità di marketing automatizzato.</strong>
            </p>
          </section>

          {/* 3. Finalità */}
          <section data-testid="privacy-section-finalita">
            <h2 className="font-display font-bold text-[#0A0A0A] text-2xl md:text-3xl tracking-tight mt-10 mb-4">
              3. Finalità del trattamento
            </h2>
            <p>I dati personali sono trattati per le seguenti finalità:</p>
            <ul className="list-disc pl-6 space-y-2 mt-3">
              <li>Erogazione dei servizi di analisi immobiliare gratuita (ValutaPro);</li>
              <li>Gestione della waitlist per il servizio OrizzontiPro e invio di una sola comunicazione al lancio;</li>
              <li>Adempimento di obblighi di legge, fiscali e contabili;</li>
              <li>Garantire il corretto funzionamento e la sicurezza del Sito.</li>
            </ul>
          </section>

          {/* 4. Base giuridica */}
          <section data-testid="privacy-section-base-giuridica">
            <h2 className="font-display font-bold text-[#0A0A0A] text-2xl md:text-3xl tracking-tight mt-10 mb-4">
              4. Base giuridica
            </h2>
            <p>Il trattamento dei dati si fonda su:</p>
            <ul className="list-disc pl-6 space-y-2 mt-3">
              <li>
                <strong>Consenso esplicito dell&apos;interessato</strong> (art. 6, par. 1, lett. a GDPR) per l&apos;iscrizione alla waitlist OrizzontiPro;
              </li>
              <li>
                <strong>Esecuzione di un contratto o misure precontrattuali</strong> (art. 6, par. 1, lett. b GDPR) per l&apos;erogazione dell&apos;analisi gratuita;
              </li>
              <li>
                <strong>Legittimo interesse</strong> (art. 6, par. 1, lett. f GDPR) per i cookie tecnici essenziali e la sicurezza del Sito;
              </li>
              <li>
                <strong>Obbligo legale</strong> (art. 6, par. 1, lett. c GDPR) per gli adempimenti fiscali e contabili.
              </li>
            </ul>
          </section>

          {/* 5. Conservazione */}
          <section data-testid="privacy-section-conservazione">
            <h2 className="font-display font-bold text-[#0A0A0A] text-2xl md:text-3xl tracking-tight mt-10 mb-4">
              5. Periodo di conservazione
            </h2>
            <ul className="list-disc pl-6 space-y-2 mt-3">
              <li>
                <strong>Email waitlist:</strong> conservata fino al lancio del servizio OrizzontiPro o fino a richiesta di cancellazione da parte dell&apos;interessato.
              </li>
              <li>
                <strong>Dati immobiliari anonimi:</strong> conservati in forma aggregata e anonima per finalità statistiche, senza limite temporale.
              </li>
              <li>
                <strong>Log tecnici di navigazione:</strong> conservati per un massimo di 12 mesi.
              </li>
            </ul>
          </section>

          {/* 6. Destinatari */}
          <section data-testid="privacy-section-destinatari">
            <h2 className="font-display font-bold text-[#0A0A0A] text-2xl md:text-3xl tracking-tight mt-10 mb-4">
              6. Destinatari dei dati
            </h2>
            <p>
              I dati personali non sono ceduti, comunicati o diffusi a terzi senza il consenso esplicito dell&apos;interessato. Possono essere trattati, in qualità di Responsabili del trattamento, da:
            </p>
            <ul className="list-disc pl-6 space-y-2 mt-3">
              <li>Fornitori di servizi di hosting e infrastruttura cloud (server situati nell&apos;Unione Europea);</li>
              <li>Consulenti professionali (commercialisti, legali) vincolati al segreto professionale;</li>
              <li>Property Advisor selezionati, esclusivamente nel caso in cui l&apos;utente ne richieda espressamente il contatto.</li>
            </ul>
          </section>

          {/* 7. Trasferimento extra-UE */}
          <section data-testid="privacy-section-trasferimento">
            <h2 className="font-display font-bold text-[#0A0A0A] text-2xl md:text-3xl tracking-tight mt-10 mb-4">
              7. Trasferimento di dati extra-UE
            </h2>
            <p>
              I dati personali sono trattati e conservati su server localizzati all&apos;interno dello Spazio Economico Europeo (SEE). In caso di eventuale trasferimento extra-UE, sarà garantita l&apos;adozione delle clausole contrattuali standard approvate dalla Commissione Europea o di altre garanzie adeguate ai sensi degli artt. 44 e seguenti del GDPR.
            </p>
          </section>

          {/* 8. Diritti */}
          <section data-testid="privacy-section-diritti">
            <h2 className="font-display font-bold text-[#0A0A0A] text-2xl md:text-3xl tracking-tight mt-10 mb-4">
              8. Diritti dell&apos;interessato
            </h2>
            <p>
              Ai sensi degli artt. 15-22 del GDPR, l&apos;utente ha diritto di:
            </p>
            <ul className="list-disc pl-6 space-y-2 mt-3">
              <li>accedere ai propri dati personali (art. 15);</li>
              <li>richiederne la rettifica (art. 16);</li>
              <li>richiederne la cancellazione (&quot;diritto all&apos;oblio&quot;, art. 17);</li>
              <li>ottenere la limitazione del trattamento (art. 18);</li>
              <li>opporsi al trattamento (art. 21);</li>
              <li>ricevere i propri dati in formato strutturato (portabilità, art. 20);</li>
              <li>revocare in qualsiasi momento il consenso prestato, senza pregiudicare la liceità del trattamento basata sul consenso prima della revoca.</li>
            </ul>
            <p className="mt-4">
              Per esercitare tali diritti è sufficiente inviare una richiesta a{" "}
              <a href="mailto:info@valutagenio.com" className="text-[#B40101] font-semibold hover:underline">
                info@valutagenio.com
              </a>
              . Il Titolare risponderà entro 30 giorni dalla ricezione.
            </p>
          </section>

          {/* 9. Reclamo */}
          <section data-testid="privacy-section-reclamo">
            <h2 className="font-display font-bold text-[#0A0A0A] text-2xl md:text-3xl tracking-tight mt-10 mb-4">
              9. Diritto di reclamo
            </h2>
            <p>
              L&apos;interessato ha il diritto di proporre reclamo all&apos;Autorità di controllo competente, ossia il{" "}
              <strong>Garante per la protezione dei dati personali</strong> (Piazza Venezia 11, 00187 Roma —{" "}
              <a href="https://www.garanteprivacy.it" target="_blank" rel="noopener noreferrer" className="text-[#B40101] font-semibold hover:underline">
                www.garanteprivacy.it
              </a>
              ), qualora ritenga che il trattamento dei propri dati personali violi il GDPR o la normativa italiana applicabile.
            </p>
          </section>

          {/* 10. Sicurezza */}
          <section data-testid="privacy-section-sicurezza">
            <h2 className="font-display font-bold text-[#0A0A0A] text-2xl md:text-3xl tracking-tight mt-10 mb-4">
              10. Sicurezza dei dati
            </h2>
            <p>
              Il Titolare adotta misure tecniche e organizzative adeguate a garantire un livello di sicurezza appropriato al rischio, tra cui crittografia delle comunicazioni (HTTPS/TLS), controllo degli accessi, backup periodici e procedure di disaster recovery.
            </p>
          </section>

          {/* 11. Modifiche */}
          <section data-testid="privacy-section-modifiche">
            <h2 className="font-display font-bold text-[#0A0A0A] text-2xl md:text-3xl tracking-tight mt-10 mb-4">
              11. Modifiche alla presente informativa
            </h2>
            <p>
              Il Titolare si riserva il diritto di modificare la presente Informativa in qualsiasi momento, dandone comunicazione tramite pubblicazione sul Sito. Si invita l&apos;utente a consultarla periodicamente.
            </p>
          </section>

          {/* 12. Candidature professionali (BOZZA — in revisione legale) */}
          <section id="candidature-professionali" data-testid="privacy-section-candidature">
            <div className="mt-12 bg-[#FFF7ED] border border-[#FED7AA] rounded-xl p-5 md:p-6">
              <p className="text-[11px] uppercase tracking-widest text-[#9A3412] font-semibold mb-2">
                Sezione in revisione legale
              </p>
              <p className="text-[14px] text-[#0A0A0A]/80">
                La presente sezione è una <strong>bozza tecnica</strong> pubblicata a supporto della raccolta candidature professionali (versione <code className="font-mono">vg2_p11b_v1_draft</code>). Il testo definitivo è in attesa di approvazione legale. In ambiente di test non devono essere trasmessi dati reali.
              </p>
            </div>
            <h2 className="font-display font-bold text-[#0A0A0A] text-2xl md:text-3xl tracking-tight mt-8 mb-4">
              12. Candidature professionali alla rete ValutaGenio (bozza)
            </h2>

            <h3 className="font-semibold text-[#0A0A0A] text-lg mt-6 mb-2">12.1 Finalità del trattamento</h3>
            <p>
              I dati raccolti tramite il modulo pubblico <a href="/professionisti" className="text-[#B40101] font-semibold hover:underline">/professionisti</a> sono trattati per valutare la coerenza della candidatura con le esigenze correnti della rete professionale ValutaGenio e, ove opportuno, per contattare il candidato in relazione alla candidatura stessa. Nessuna finalità di marketing è attivata dall&apos;invio del modulo.
            </p>

            <h3 className="font-semibold text-[#0A0A0A] text-lg mt-6 mb-2">12.2 Categorie di dati trattati</h3>
            <p>
              Dati di contatto (nome, cognome, denominazione professionale, email, telefono), dati professionali (ruolo, ambito, ambito di copertura, descrizione, motivazione), dati facoltativi relativi a eventuali iscrizioni ad albi/ordini e sito o profilo pubblico. Non vengono richiesti documenti d&apos;identità, allegati, dati bancari, dati particolari (art. 9 GDPR) né dati relativi a condanne penali.
            </p>

            <h3 className="font-semibold text-[#0A0A0A] text-lg mt-6 mb-2">12.3 Base giuridica</h3>
            <p>
              La base giuridica del trattamento è <strong>oggetto di validazione legale</strong>. La bozza fa riferimento all&apos;esecuzione di misure precontrattuali su richiesta dell&apos;interessato (art. 6.1 lett. b GDPR) e all&apos;interesse legittimo del Titolare a valutare candidature professionali (art. 6.1 lett. f GDPR).
            </p>

            <h3 className="font-semibold text-[#0A0A0A] text-lg mt-6 mb-2">12.4 Obbligatorietà dei campi</h3>
            <p>
              I campi contrassegnati come obbligatori sono necessari per la valutazione della candidatura. Il mancato conferimento comporta l&apos;impossibilità di procedere. I campi facoltativi (sito, iscrizione ad albo, numero di iscrizione, denominazione dello studio) possono aiutare la valutazione ma non sono richiesti.
            </p>

            <h3 className="font-semibold text-[#0A0A0A] text-lg mt-6 mb-2">12.5 Modalità del trattamento</h3>
            <p>
              I dati sono trattati con strumenti elettronici, con misure di sicurezza tecniche e organizzative adeguate. L&apos;accesso alle candidature è limitato ai soli soggetti autorizzati dal Titolare. Le motivazioni interne di rifiuto non sono mai comunicate al candidato.
            </p>

            <h3 className="font-semibold text-[#0A0A0A] text-lg mt-6 mb-2">12.6 Destinatari dei dati</h3>
            <p>
              I dati non sono comunicati a terzi né diffusi. L&apos;ammissione alla rete professionale implica il collegamento della candidatura a un record interno della rete estesa (Extended Network), gestito unicamente dal Titolare. Non viene creata alcuna pagina profilo pubblica.
            </p>

            <h3 className="font-semibold text-[#0A0A0A] text-lg mt-6 mb-2">12.7 Periodo di conservazione</h3>
            <p>
              Il periodo di conservazione è <strong>oggetto di validazione legale</strong>. La bozza prevede la conservazione delle candidature fintanto che l&apos;esito rimane in valutazione o attivo, e dei dati relativi ai candidati ammessi per la durata del rapporto con la rete estesa e comunque nel rispetto degli obblighi di legge.
            </p>

            <h3 className="font-semibold text-[#0A0A0A] text-lg mt-6 mb-2">12.8 Diritti dell&apos;interessato</h3>
            <p>
              L&apos;interessato può esercitare i diritti di cui agli artt. 15-22 GDPR scrivendo a{" "}
              <a href="mailto:info@valutagenio.com" className="text-[#B40101] font-semibold hover:underline">info@valutagenio.com</a>. L&apos;esercizio dei diritti è gratuito, salvo i casi previsti dalla normativa.
            </p>

            <h3 className="font-semibold text-[#0A0A0A] text-lg mt-6 mb-2">12.9 Ammissione alla rete</h3>
            <p>
              L&apos;ammissione alla rete estesa ValutaGenio richiede una <strong>decisione esplicita del team</strong>. Non è una certificazione professionale, non implica verifica automatica delle credenziali, non garantisce l&apos;assegnazione di incarichi e non comporta esclusive territoriali. La rete estesa è un bacino di professionisti conosciuti; il coinvolgimento su singoli progetti (Project Circle) è deciso caso per caso dal Property Advisor.
            </p>
          </section>

          {/* Contatti */}
          <section data-testid="privacy-section-contatti" className="mt-12">
            <div className="bg-[#F5F5F5] rounded-xl p-6 md:p-8 border border-[#E5E5E5]">
              <h3 className="font-display font-bold text-[#0A0A0A] text-xl tracking-tight mb-2">
                Hai domande sulla privacy?
              </h3>
              <p className="text-[#0A0A0A]/75">
                Scrivici a{" "}
                <a href="mailto:info@valutagenio.com" className="text-[#B40101] font-semibold hover:underline">
                  info@valutagenio.com
                </a>
                . Rispondiamo entro 30 giorni.
              </p>
            </div>
          </section>

        </div>
      </section>

      <Footer />
    </main>
  );
}
